import { HttpClient, HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { EstadoModel } from 'src/app/models/Estado.model';
import { UserProfileModel } from 'src/app/models/user-profile.model';
import { UserModel } from 'src/app/models/user.modetl';
import { v_userprofile } from 'src/app/models/v_userprofile.model';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-autorizacion',
    templateUrl: './autorizacion.component.html',
    styleUrls: ["../../../assets/css/style.scss"],
})
/** autorizacion component*/
export class AutorizacionComponent implements OnInit {
    /** autorizacion ctor */
    constructor(public http: HttpClient, private SpinnerService: NgxSpinnerService, private _builder: FormBuilder, private cdRef: ChangeDetectorRef) {

    }

    public v_userProfile: v_userprofile[];
    public Iata: any[] = [];
    public EstadoSolicitud: any[] = [];
    public NombreCompleto: any[] = [];
    public IdentificacionTercero: any[] = [];
    public NombreTercero: any[] = [];
    public AreaNegocio: any[] = [];
    public Cargo: any[] = [];
    public Email: any[] = [];
    public Aprobador: any[] = [];
    public Perfil: any[] = [];
    public Estados: EstadoModel[];
    public IdEstadosObject: any[] = [];
    public NewUser: UserModel = new UserModel();
    displayModalEdit: boolean;
    FormAddUser: FormGroup;
    public UpdateUser: UserModel = new UserModel();
    submitted = false;



    ngOnInit(): void {
        this.getAll();
        this.FormAddUser = this._builder.group({
            IdUsuario: [ [Validators.required]],
            EstadoSolicitud: [[Validators.required]],
            NombreCompleto: [[Validators.required, Validators.maxLength(50)]],
            Email: [[Validators.required, Validators.email, Validators.maxLength(100)]],
            IdentificacionTercero: [ [Validators.required, Validators.maxLength(30)]],
            AreaNegocio: [ [Validators.required, Validators.maxLength(20)]],
            Cargo: [[Validators.required, Validators.maxLength(20)]],
            NombreTercero: [ [Validators.required, Validators.maxLength(50)]],
            Iata: [ [Validators.required, Validators.maxLength(50)]]
        });

    }
    getAll() {
        this.SpinnerService.show();
        let UserInf: any;
        UserInf = localStorage.getItem("ResponseData");
        let body = new HttpParams();
        body = body.set("data", UserInf);
        this.http.post<v_userprofile[]>(window.location.origin + "/api/User/GetUsers/", body).subscribe((data) => {
            this.v_userProfile = data;
            console.log("-------Users------");
            console.log(this.v_userProfile);
            let iata = {};
            this.Iata = [];
            let stadosolicitud = {};
            this.EstadoSolicitud = [];
            let nombrecompleto = {};
            this.NombreCompleto = [];
            let idtercero = {};
            this.IdentificacionTercero = [];
            let ntercero = {};
            this.NombreTercero = [];
            let areanegocio = {};
            this.AreaNegocio = [];
            let cargo = {};
            this.Cargo = [];
            let email = {};
            this.Email = [];
            let aprobador = {};
            this.Aprobador = [];
            let perfil = {};
            this.Perfil = [];
            for (let index = 0; index < this.v_userProfile.length; index++) {
                iata = { label: this.v_userProfile[index].Usuario.Iata, value: this.v_userProfile[index].Usuario.Iata };
                nombrecompleto = { label: this.v_userProfile[index].Usuario.NombreCompleto, value: this.v_userProfile[index].Usuario.NombreCompleto };
                idtercero = { label: this.v_userProfile[index].Usuario.IdentificacionTercero, value: this.v_userProfile[index].Usuario.IdentificacionTercero };
                ntercero = { label: this.v_userProfile[index].Usuario.NombreTercero, value: this.v_userProfile[index].Usuario.NombreTercero };
                areanegocio = { label: this.v_userProfile[index].Usuario.AreaNegocio, value: this.v_userProfile[index].Usuario.AreaNegocio };
                cargo = { label: this.v_userProfile[index].Usuario.Cargo, value: this.v_userProfile[index].Usuario.Cargo };
                email = { label: this.v_userProfile[index].Usuario.Email, value: this.v_userProfile[index].Usuario.Email };
                aprobador = { label: this.v_userProfile[index].Usuario.Aprobador, value: this.v_userProfile[index].Usuario.Aprobador };
                perfil = { label: this.v_userProfile[index].Perfil.Nombre, value: this.v_userProfile[index].Perfil.Nombre };

                if (this.Iata.find((x) => x.label === this.v_userProfile[index].Usuario.Iata) == null) {
                    this.Iata.push(iata);
                    this.Iata.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                //Validaciones de los estados
                if (this.v_userProfile[index].Usuario.EstadoSolicitud === 2) {
                    stadosolicitud = { label: "En Espera", value: this.v_userProfile[index].Usuario.EstadoSolicitud };
                }
                if (this.v_userProfile[index].Usuario.EstadoSolicitud === 3) {
                    stadosolicitud = { label: "Aprobado", value: this.v_userProfile[index].Usuario.EstadoSolicitud };
                }
                if (this.v_userProfile[index].Usuario.EstadoSolicitud === 4) {
                    stadosolicitud = { label: "No Aprobado", value: this.v_userProfile[index].Usuario.EstadoSolicitud };
                }
                if (this.v_userProfile[index].Usuario.EstadoSolicitud === 5) {
                    stadosolicitud = { label: "Dado de Baja", value: this.v_userProfile[index].Usuario.EstadoSolicitud };
                }

                if (this.EstadoSolicitud.find((x) => x.value === this.v_userProfile[index].Usuario.EstadoSolicitud) == null) {
                    this.EstadoSolicitud.push(stadosolicitud);
                    this.EstadoSolicitud.sort((a, b) => { if (a.value < b.value) { return -1; } if (a.value > b.value) { return 1; } return 0; });
                }

                if (this.NombreCompleto.find((x) => x.label === this.v_userProfile[index].Usuario.NombreCompleto) == null) {
                    this.NombreCompleto.push(nombrecompleto);
                    this.NombreCompleto.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                if (this.IdentificacionTercero.find((x) => x.label === this.v_userProfile[index].Usuario.IdentificacionTercero) == null) {
                    this.IdentificacionTercero.push(idtercero);
                    this.IdentificacionTercero.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                if (this.NombreTercero.find((x) => x.label === this.v_userProfile[index].Usuario.NombreTercero) == null) {
                    this.NombreTercero.push(ntercero);
                    this.NombreTercero.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                if (this.AreaNegocio.find((x) => x.label === this.v_userProfile[index].Usuario.AreaNegocio) == null) {
                    this.AreaNegocio.push(areanegocio);
                    this.AreaNegocio.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                if (this.Cargo.find((x) => x.label === this.v_userProfile[index].Usuario.AreaNegocio) == null) {
                    this.Cargo.push(areanegocio);
                    this.Cargo.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                if (this.Email.find((x) => x.label === this.v_userProfile[index].Usuario.Email) == null) {
                    this.Email.push(email);
                    this.Email.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                if (this.Aprobador.find((x) => x.label === this.v_userProfile[index].Usuario.Aprobador) == null) {
                    this.Aprobador.push(aprobador);
                    this.Aprobador.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                if (this.Perfil.find((x) => x.label === this.v_userProfile[index].Perfil.Nombre) == null) {
                    this.Perfil.push(perfil);
                    this.Perfil.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }

            }
            this.SpinnerService.hide();
        });

        this.http.post<EstadoModel[]>(window.location.origin + "/api/Estados/GetEstados", body).subscribe((res) => {
            // Success
            this.Estados = res;
            console.log("------ESTADOS-------")
            console.log(this.Estados)
            //Llenando arreglo para Select de Bases
            var Estado = {};
            this.IdEstadosObject = [];
            for (let index = 0; index < this.Estados.length; index++) {
                Estado = {Id: this.Estados[index].Id, Nombre: this.Estados[index].Nombre};
                this.IdEstadosObject.push(Estado);
            }

            //this.SetInitValidation();

            this.SpinnerService.hide();
        });
    }

    
  setSelect(element, input, data) {
    //Tratamiento del element antes de insertar en input
    var elem = element.target.value;

    if (input == "EstadoSolicitud") {
      if (data == "UpdateUser") {
        this.UpdateUser.EstadoSolicitud = elem;
      } else {
        this.NewUser.EstadoSolicitud = elem;
      }
    }
  }


    get formAddUser() {
        return this.FormAddUser.controls;
    }

    public GetIdUser(data: UserModel) {
        this.UpdateUser = new UserModel();
        this.SpinnerService.show();
        var request = JSON.stringify(data);
        let body = new HttpParams();
        body = body.set("ObjectRequest", request);
        const bodyUser = {
          ObjectRequest: request,
        };
        this.http.post<UserModel>(window.location.origin + "/api/User/GetIdUser", bodyUser)
          .toPromise().then((res) => {   
            //Objeto para actualizar
            this.UpdateUser = res;
            this.cdRef.detectChanges();
            //Servicio de Loader-Spinner
            this.SpinnerService.hide();
            //this.getAll();
            
          })
          .catch((err) => {
            // error
            console.error(err);
            this.SpinnerService.hide();
          });
      }
     
    public UpdateUsers(data: UserModel) {
        if (this.FormAddUser.invalid) {
            return;
        }
        //Spinner de Carga
        debugger;
        this.SpinnerService.show();
        var user = JSON.parse(localStorage.getItem("ResponseData"))
        //Seteando data de Auditoria
        data.Aprobador = user.Email ;
        data.ModificadoPor = user.Email;
        data.FechaModificado = new Date();

        // Construyendo body de la peticion
        var request = JSON.stringify(data);
        let body = new HttpParams();
        body = body.set("data", request);
        const bodyUser = {
            ObjectRequest: request,
        };


        /**** TODO: Validacion de Formulario antes de Enviar peticion  ****/

        this.http
            .post(window.location.origin + "/api/User/UpdateUser", bodyUser)
            .toPromise()
            .then((res) => {
                // Success

                console.log(res);
                this.getAll()
                this.HideModalDialogEditProfile();
                this.cdRef.detectChanges();
                this.SpinnerService.hide();
                Swal.fire({
                    //position: 'top-end',
                    icon: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500,
                });
            })
            .catch((err) => {
                // error
                console.error(err);
                this.SpinnerService.hide();
            });
    }
    HideModalDialogEditProfile() {
        this.onReset();
        this.displayModalEdit = false;
    }
    onReset() {
        this.submitted = false;
        this.FormAddUser.reset();
    }

    showModalDialogEdit() {
        this.displayModalEdit = true;
    }
}